import { render, staticRenderFns } from "./UserTodo.vue?vue&type=template&id=9a21bc70&scoped=true&"
import script from "./UserTodo.vue?vue&type=script&lang=js&"
export * from "./UserTodo.vue?vue&type=script&lang=js&"
import style0 from "./UserTodo.vue?vue&type=style&index=0&id=9a21bc70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a21bc70",
  null
  
)

export default component.exports